import {useEffect} from 'react'
import {useNavigate} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useConfrimCookie from 'shared/model/useConfrimCookie'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePutManagerPassowrd = (idRef, newPwRef) => {
	const navigate = useNavigate()

	const [fetchResult, fetchRequest] = useFetch()
	const [, , deleteConfrimCookie] = useConfrimCookie()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	const request = () => {
		const rolePath = getApiRolePath(userRole)
		fetchRequest('PUT', `/${rolePath}/auth/manager/password`, {
			id: idRef?.current?.value,
			new_password: newPwRef?.current?.value,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				setAlert('비밀번호 변경이 완료되었습니다.')
				navigate('/')
				break
			case 400:
				if (fetchResult?.data?.error_code === 'id')
					setAlert('아이디 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'new_password')
					setAlert('비밀번호 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1) {
					setAlert('가입된 계정이 아닙니다.')
				}
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePutManagerPassowrd
